import { Box, Paper, Typography, Alert, Select, MenuItem } from "@mui/material";
import { useEffect, useState } from "react";
import { callApi } from "../../helpers/CallAPI";
import { getApiKey } from "../../helpers/Utils";
import { apiBaseUrl, apiPaths } from "../../constants/ApiUrl";
import { useNavigate } from "react-router-dom";
import ButtonsComponent from "./form/ButtonsComponent";
import FormComponent from "./form/FormComponent";

const UpdateDashboard: React.FC<{ handleCancel }> = ({ handleCancel }) => {
  const [dashboardList, setDashboardList] = useState([]);
  const [displayTypes, setDisplayTypes] = useState([]);
  const [selectedDisplayType, setSelectedDisplayType] = useState(null);
  const [selectedDashboard, setSelectedDashboard] = useState(null);
  const [selectedDashboardDetail, setSelectedDashboardDetail] = useState(null);
  const [hashtagText, setHashTagText] = useState("");
  const [inTitleContent, setInTitleContent] = useState(false);
  const [nameError, setNameError] = useState("");
  const [hashtagsError, setHashtagsError] = useState("");
  const [hashtagsTextError, setHashtagsTextError] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState<
    "info" | "success" | "error" | "warning"
  >("info");
  const navigate = useNavigate();
  useEffect(() => {
    getData();
  }, []);
  const getData = () => {
    const apiKey = getApiKey();
    if (apiKey) {
      callApi(apiKey, apiBaseUrl + apiPaths.versions, "GET")
        .then((data) => {
          setDashboardList(data);
        })
        .catch((e) => {
          const error = JSON.parse(e.message);
          if (error.status === 403) {
            navigate("/login");
          }
        });
      callApi(apiKey, apiBaseUrl + apiPaths.displayType, "GET")
        .then((data) => {
          setDisplayTypes(data);
        })
        .catch((e) => {
          const error = JSON.parse(e.message);
          if (error.status === 403) {
            navigate("/login");
          }
        });
    } else {
      navigate("/login");
    }
  };
  const getDashboardDetail = (did) => {
    const apiKey = getApiKey();
    if (apiKey) {
      callApi(
        apiKey,
        apiBaseUrl + apiPaths.dashboardVersion + "?did=" + did,
        "GET"
      )
        .then((data) => {
          setSelectedDashboardDetail(data);
          setSelectedDisplayType(data.displayType);
        })
        .catch((e) => {
          const error = JSON.parse(e.message);
          if (error.status === 403) {
            navigate("/login");
          }
        });
    } else {
      navigate("/login");
    }
  };
  const handleSelectDashboard = (event) => {
    const did = event.target.value;
    setSelectedDashboard(did);
    getDashboardDetail(did);
  };
  const handleAddHashtag = () => {
    if (!hashtagText) {
      setHashtagsTextError("Please input the hashtag before add");
      return;
    } else {
      setHashtagsTextError("");
    }
    const tmpDashboardDetail = { ...selectedDashboardDetail };
    tmpDashboardDetail.hashtags = [
      ...selectedDashboardDetail.hashtags,
      { hashtag: hashtagText, intitlecontent: inTitleContent },
    ];
    setSelectedDashboardDetail(tmpDashboardDetail);
    setHashTagText("");
    setInTitleContent(false);
  };

  const handleRemoveHashtag = (index) => {
    const tmpDashboardDetail = { ...selectedDashboardDetail };
    tmpDashboardDetail.hashtags = selectedDashboardDetail.hashtags.filter(
      (_, i) => i !== index
    );
    setSelectedDashboardDetail(tmpDashboardDetail);
  };

  const handleSubmit = () => {
    var validated = true;
    if (!selectedDashboardDetail.name) {
      setNameError("Please input the dashboard name");
      validated = false;
    } else {
      setNameError("");
    }
    if (selectedDashboardDetail.hashtags.length === 0) {
      setHashtagsError("Please add at least one hashtag");
      validated = false;
    } else {
      setHashtagsError("");
    }
    if (!validated) {
      return;
    }
    const apiKey = getApiKey();
    if (apiKey) {
      callApi(
        apiKey,
        apiBaseUrl + apiPaths.update + "?did=" + selectedDashboard,
        "PUT",
        JSON.stringify({
          name: selectedDashboardDetail.name,
          hashtags: selectedDashboardDetail.hashtags,
          displayType: selectedDisplayType,
        })
      )
        .then((data) => {
          const findDashboardInList = dashboardList.find(
            (x) => x.did === selectedDashboard
          );
          const tmpDashboardList = dashboardList;
          tmpDashboardList[dashboardList.indexOf(findDashboardInList)].name =
            selectedDashboardDetail.name;
          tmpDashboardList[
            dashboardList.indexOf(findDashboardInList)
          ].hashtags = selectedDashboardDetail.hashtags;
          tmpDashboardList[
            dashboardList.indexOf(findDashboardInList)
          ].displayType = selectedDisplayType;
          setDashboardList(tmpDashboardList);
          setSelectedDashboard(null);
          setSelectedDashboardDetail(null);
          setHashTagText("");
          setInTitleContent(false);
          setMessage("Update successfully");
          setMessageType("success");
          setShowMessage(true);
        })
        .catch((e) => {
          const error = JSON.parse(e.message);
          if (error.status === 403) {
            navigate("/login");
          } else {
            setMessage("Something went wrong. Please check again");
            setMessageType("error");
            setShowMessage(true);
          }
        });
      setTimeout(() => {
        setShowMessage(false);
        setMessage("");
      }, 5000);
    } else {
      navigate("/login");
    }
  };

  return (
    <Box className="paper-container">
      <Paper className="paper-main" elevation={4}>
        <Typography
          variant="h5"
          align="center"
          gutterBottom
          sx={{ color: "#ffffff" }}
        >
          Update Dashboard
        </Typography>

        {/* Name Field */}
        {showMessage && message ? (
          <Alert
            severity={messageType}
            sx={{ width: "90%", marginTop: "20px", marginBottom: "10px" }}
          >
            {message}
          </Alert>
        ) : null}
        <Select
          fullWidth
          displayEmpty
          renderValue={(value: any) => {
            if (!value) {
              return <Typography color="gray">Select dashboard</Typography>;
            }
            return dashboardList.find((x) => x.did === value).name;
          }}
          value={selectedDashboard ? selectedDashboard : null}
          sx={{
            color: "#ffffff",
            borderRadius: "4px",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#444",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#888",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#1976d2",
            },
            "& .MuiSelect-icon": {
              color: "#ffffff",
            },
            marginTop: 3,
          }}
          onChange={(e) => handleSelectDashboard(e)}
        >
          {dashboardList.map((dashboard, index) => {
            return (
              <MenuItem key={index} value={dashboard.did}>
                {dashboard.name}
              </MenuItem>
            );
          })}
        </Select>
        {selectedDashboardDetail && (
          <>
            <FormComponent
              name={selectedDashboardDetail.name}
              handleAddHashtag={handleAddHashtag}
              handleRemoveHashtag={handleRemoveHashtag}
              hashtagText={hashtagText}
              hashtags={selectedDashboardDetail.hashtags}
              hashtagsError={hashtagsError}
              hashtagsTextError={hashtagsTextError}
              inTitleContent={inTitleContent}
              nameError={nameError}
              onChangeHashtagText={(e) => {
                if (e.target.value.trim()) {
                  setHashtagsTextError("");
                }
                setHashTagText(e.target.value);
              }}
              onChangeInTitleContent={(_, checked) => {
                setInTitleContent(checked);
              }}
              onChangeName={(e) => {
                if (e.target.value.trim()) {
                  setNameError("");
                } else {
                  setNameError("Please input the dashboard name");
                }
                const tmpDashboardDetail = { ...selectedDashboardDetail };
                tmpDashboardDetail.name = e.target.value;
                setSelectedDashboardDetail(tmpDashboardDetail);
              }}
              onSelectDisplayType={(e) => {
                const value = e.target.value;
                setSelectedDisplayType(value);
              }}
              displayTypes={displayTypes}
              selectedDisplayType={selectedDisplayType}
            />
            <ButtonsComponent
              handleCancel={handleCancel}
              handleSubmit={handleSubmit}
            />
          </>
        )}
      </Paper>
    </Box>
  );
};

export default UpdateDashboard;
